var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dr-apply-base", {
    attrs: { "list-name": "达人申请表", "order-type": 1 }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }